import { render, staticRenderFns } from "./events-journal-service.vue?vue&type=template&id=d29a9eb0"
import script from "./events-journal-service.vue?vue&type=script&lang=ts"
export * from "./events-journal-service.vue?vue&type=script&lang=ts"
import style0 from "./events-journal-service.vue?vue&type=style&index=0&id=d29a9eb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports